import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import { Box, Grid, Typography, useTheme } from '@mui/material';
import { ReactNode } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

type IMultilineTextInputProps = {
  name: string;
  label: ReactNode;
  placeholder: string;
  textSize: number;
  onChange?: () => void;
};

export const MultilineTextInput = ({
  name,
  label,
  placeholder,
  textSize,
  onChange,
}: IMultilineTextInputProps) => {
  const theme = useTheme();
  const { control } = useFormContext();
  const fieldValue: string = useWatch({ control, name }) || '';

  return (
    <Grid sx={{ position: 'relative' }} size={{ xs: 12, md: 12 }}>
      <FormInput
        name={name}
        label={label}
        placeholder={placeholder}
        onChange={onChange}
        multiline
        rows={4}
        fullWidth
      />
      <Typography
        sx={{ color: 'textSecondary', position: 'absolute', bottom: 16, right: 16 }}
        variant="body2"
      >
        <Box
          component={'span'}
          sx={{
            color: fieldValue?.length > textSize ? theme.palette.error.main : 'inherit',
          }}
        >
          {fieldValue?.length}
        </Box>
        {` / ${textSize}`}
      </Typography>
    </Grid>
  );
};
